import { eAchPullPayerType } from '../eAchPullPayerType';
import { eDepositCategory } from '../eDepositCategory';
import { UUID } from '../../../shared/UUID';
import { IAchPullDepositData } from '../IAchPullDepositData';

// from swagger docs
export interface IExpectedAchPullDepositRequest {
  amountCents: number;
  payerType: eAchPullPayerType;
  category: eDepositCategory;
  memo?: string;
  wellsFargoTransactionNumber?: string;
  ownerId?: UUID;
  achAccountId?: UUID;
}

// the PUT endpoint requires the id of the request.
export interface IExpectedAchPullDepositRequestWithId extends IExpectedAchPullDepositRequest {
  id: UUID;
}

export const convertIACHPullDepositDataToIExpectedAchPullDepositRequestWithId = ({
  category,
  id,
  amountCents,
  memo,
  wellsFargoTransactionNumber,
  ownerId,
  payerType,
  account,
}: IAchPullDepositData): IExpectedAchPullDepositRequestWithId => ({
  id,
  amountCents,
  //despite the ||, the form validation *should* enforce the presence of the category.
  category: category || eDepositCategory.other,
  memo,
  wellsFargoTransactionNumber,
  ownerId,
  achAccountId: account?.id || '',
  payerType,
});
